import { render, staticRenderFns } from "./changearchival.vue?vue&type=template&id=717ee08e&scoped=true&"
import script from "./changearchival.vue?vue&type=script&lang=js&"
export * from "./changearchival.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./changearchival.vue?vue&type=style&index=1&id=717ee08e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717ee08e",
  null
  
)

export default component.exports